/**
 * 引用filter的入口页面
 */
export enum FilterEntry {
  KuiklyKotlinDetail='KuiklyKotlinDetail',
  KuiklyKotlinAnalysis='KuiklyKotlinAnalysis',
  CpuList = 'cpuList',
  CpuDetails = 'cpuDetails',
  CpuAnalysis =  'cpuAnalysis',
  MemoryDetailDetail = 'memoryDetailDetail',
  MemoryDetailAnalysis = 'memoryDetailAnalysis',
  AndroidANRCaller = 'androidAnrCaller',
  CrashCaller = 'crashCaller',
  CrashList = 'crashList',
  CrashDetail = 'crashDetail',
  CrashAnalysis = 'crashAnalysis',
  CrashTable = 'crashTable',
  CrashSplit = 'crashSplit',
  CrashLogFrequency = 'CrashLogFrequency',


  ANRList = 'anrList',
  ANRDetail = 'anrDetail',
  ANRAnalysis = 'anrAnalysis',
  ANRSplit = 'anrSplit',
  ANRTable = 'anrTable',
  ANRIOSList = 'anrIOSList',
  ANRIOSTable = 'anrIOSTable',
  ANRIOSDetail = 'anrIOSDetail',
  ANRIOSAnalysis = 'anrIOSAnalysis',
  ANRLogFrequency = 'ANRLogFrequency',

  ErrorList = 'errorList',
  ErrorDetail = 'errorDetail',
  ErrorAnalysis = 'errorAnalysis',
  ErrorTable = 'errorTable',
  ErrorSplit = 'errorSplit',
  ErrorLogFrequency = 'ErrorLogFrequency',
  ErrorCaller = 'errorCaller',


  FoomLogFrequency = 'FoomLogFrequency',
  FoomList = 'foomList',
  FoomDetail = 'foomDetail',
  FoomAnalysis = 'foomAnalysis',
  FoomTable = 'foomTable',
  FoomSplit= 'foomSplit',
  FoomIOSList = 'foomIOSList',
  FoomIOSTable = 'foomIOSTable',
  FoomIOSDetail = 'foomIOSDetail',
  // ios foom 详情下钻分析
  FoomIOSAnalysis = 'foomIOSAnalysis',
  // ios foom指标分析
  FoomIOSIndicatorAnalysis = 'foomIOSIndicatorAnalysis',
  FoomMallocList = 'foomMallocList',
  FoomMallocDetail = 'foomMallocDetail',
  FoomMallocAnalysis = 'foomMallocAnalysis',

  DropFrameList = 'dropFrameList',
  DropFrameDetail = 'dropFrameDetail',
  DropFrameAnalysis = 'dropFrameAnalysis',
  DropFrameIndicatorAnalysis = 'dropFrameIndicatorAnalysis',
  MultiHotspotList = 'multiHotspotList',
  MultiHotspotDetail = 'multiHotspotDetail',
  MultiHotspotAnalysis = 'multiHotspotAnalysis',

  MemoryJavaLeakList = 'memoryJavaLeakList',
  MemoryJavaLeakDetail = 'memoryJavaLeakDetail',
  MemoryJavaLeakAnalysis = 'memoryJavaLeakAnalysis',

  MemoryFdList = 'memoryFdList',
  MemoryFdDetail = 'memoryFdDetail',
  MemoryFdAnalysis = 'memoryFdAnalysis',

  MemoryNativeList = 'memoryNativeList',
  MemoryNativeDetail = 'memoryNativeDetail',
  MemoryNativeAnalysis = 'memoryNativeAnalysis',

  MemoryBigPcList = 'memoryBigPcList',
  MemoryBigPcDetail = 'memoryBigPcDetail',
  MemoryBigPcAnalysis = 'memoryBigPcAnalysis',

  MemoryVcLeakList = 'memoryVcLeakList',
  MemoryVcLeakDetail = 'memoryVcLeakDetail',
  MemoryVcLeakAnalysis = 'memoryVcLeakAnalysis',

  MemoryBadMallocList = 'memoryBadMallocList',
  MemoryBadMallocDetail = 'memoryBadMallocDetail',
  MemoryBadMallocAnalysis = 'memoryBadMallocAnalysis',
  MemoryHighList = 'memoryHighList',
  MemoryHighDetail = 'memoryHighDetail',
  MemoryHighAnalysis = 'memoryHighAnalysis',

  MemoryVmmapList = 'memoryVmmapList',
  VmmapDetailList = 'vmmapDetailList',

  // 指标分析
  MemoryIndicatorAnalysis = 'memoryAnalysis',

  MetricKitLog = 'metricKitLog',

  MemGraphList = 'memGraphList',

  LaunchList = 'launchList',
  LaunchIndicatorAnalysis = 'launchIndicatorAnalysis',
  LaunchIndicatorOverviewAnalysis = 'launchIndicatorOverviewAnalysis',

  // 合规
  ComplianceList = 'complianceList',
  ComplianceFuncList = 'complianceFuncList',
  ComplianceFuncDetail = 'complianceFuncDetail',
  ComplianceTrend = 'complianceTrend',
  ComplianceDownloadList = 'complianceDownloadList',
  ComplianceSelfLaunchList = 'complianceSelfLaunchList',
  ComplianceReport = 'complianceReport',
  ComplianceNetworkList = 'complianceNetworkList',
  ComplianceModulesList = 'complianceModulesList',
  ComplianceFileList = 'complianceFileList',
  ComplianceScan = 'complianceScan',
  CompliancePrivacyFlare = 'compliancePrivacyFlare',

  // 流量
  NetList = 'netList',
  NetDetail = 'netDetail',
  NetAnalysis = 'netAnalysis',

  // 网络
  NetHttpList = 'netHttpList',
  NetHttpDetail = 'netHttpDetail',
  NetHttpAnalysis = 'netHttpAnalysic',
  NetHttpDomainDetail = 'netHttpDomainDetail',

  // 跟踪
  Track = 'track',
  PowerExceptionTypeList = 'PowerExceptionTypeList',
  PowerExceptionTypeAnalysis = 'PowerExceptionTypeAnalysis',
  PowerExceptionTypeDetail = 'powerExceptionTypeDetail',

  // 大模型可观测
  LlmObservability = 'llmObservability',
}

export enum FormColumnGroup {
  UserInfo = 'userInfo',
  ApplicationInfo = 'applicationInfo',
  DeviceInfo = 'deviceinfo',
  ContextInfo = 'contextInfo',
  exceptionInfo = 'exceptionInfo',
  Tag = 'tag',
  Custom = 'custom'
}
